import React from 'react';
import { Shield, Users, Clock } from 'lucide-react';

export function About() {
  return (
    <div className="max-w-7xl mx-auto py-12 px-4">
      <div className="text-center mb-16 fade-in">
        <h1 className="text-4xl font-bold mb-4 slide-up">Om os</h1>
        <p className="text-xl text-gray-600 max-w-3xl mx-auto slide-up" style={{ animationDelay: '0.2s' }}>
          Vi er Danmarks eneste platform, hvor du bliver kontaktet af selvstændige forsikringsformidlere.
          Vores mission er at gøre forsikring nem og personlig – helt uforpligtende.
        </p>
      </div>

      <div className="mb-16 slide-up" style={{ animationDelay: '0.3s' }}>
        <img
          src="https://images.unsplash.com/photo-1600880292203-757bb62b4baf?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80"
          alt="Business meeting"
          className="w-full h-[400px] object-cover rounded-xl"
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-16 stagger-children">
        <div className="text-center">
          <div className="bg-green-50 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
            <Shield className="w-8 h-8 text-green-600" />
          </div>
          <h3 className="text-xl font-semibold mb-2">Ekspertise</h3>
          <p className="text-gray-600">
            Vores formidlere er certificerede eksperter med mange års erfaring i branchen
          </p>
        </div>
        <div className="text-center">
          <div className="bg-green-50 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
            <Users className="w-8 h-8 text-green-600" />
          </div>
          <h3 className="text-xl font-semibold mb-2">Personlig Service</h3>
          <p className="text-gray-600">
            Du får skræddersyet rådgivning tilpasset netop dine behov
          </p>
        </div>
        <div className="text-center">
          <div className="bg-green-50 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
            <Clock className="w-8 h-8 text-green-600" />
          </div>
          <h3 className="text-xl font-semibold mb-2">Hurtig Response</h3>
          <p className="text-gray-600">
            Vi garanterer kontakt inden for 24 timer
          </p>
        </div>
      </div>

      <div className="bg-green-50 rounded-xl p-8 md:p-12 slide-up" style={{ animationDelay: '0.4s' }}>
        <h2 className="text-2xl font-bold mb-6">Vores Værdier</h2>
        <ul className="space-y-4">
          <li className="flex items-center text-gray-700">
            <span className="text-green-600 mr-2">✓</span>
            Transparens i alle processer
          </li>
          <li className="flex items-center text-gray-700">
            <span className="text-green-600 mr-2">✓</span>
            Uafhængig og objektiv rådgivning
          </li>
          <li className="flex items-center text-gray-700">
            <span className="text-green-600 mr-2">✓</span>
            Fokus på kundens behov
          </li>
          <li className="flex items-center text-gray-700">
            <span className="text-green-600 mr-2">✓</span>
            Høj faglighed og professionalisme
          </li>
        </ul>
      </div>
    </div>
  );
}